import React from 'react';
import { graphql } from 'gatsby';
import Typography from '../../primitives/typography';
import Col from '../../primitives/grid/col';
import Row from '../../primitives/grid/row';
import Container from '../../primitives/grid/container';
import { colors } from '../../primitives/colors';
import { useMicrosite } from '../../../contexts/franchise/microsite-context';
import { useLocator } from '../../../contexts/franchise/locator-provider';
import PhoneNumber from '../../molecules/phone-number';
import { StyledButtonAsLink } from '../../primitives/styled-button';
import formatPhoneLink from '../../utils/format-phone-link';
import Skeleton from '../../primitives/skeleton';
import { FormBuilder } from '../form';
import { breakpoints } from '../../primitives/tokens';

const FranchiseFormCta = ({
    title,
    body_text: bodyText,
    linked_form_id: linkedFormId,
}): JSX.Element => {
    const {
        franchise: micrositeFranchise,
    } = useMicrosite();
    const { franchise: locatorFranchise } = useLocator();
    const franchise = micrositeFranchise || locatorFranchise?.data;
    const { mainPhone: frPhone } = franchise ?? {};

    return (
        <section css={{
            position: 'relative',
            overflow: 'hidden',
            backgroundColor: colors.shadesBlack,
        }}
        >
            <Container>
                <Row>
                    <Col
                        breakpoints={{
                            dt: { span: 6 },
                        }}
                        css={{
                            margin: 'auto',
                        }}
                    >
                        <div css={{
                            marginTop: '80px',
                            marginBottom: '96px',
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'flex-start',
                            justifyContent: 'center',
                            [breakpoints.mb]: {
                                marginTop: '24px',
                                marginBottom: '24px',
                            },
                        }}
                        >
                            <Typography
                                fontSize={{
                                    dt: '4xl',
                                    mb: '2xl',
                                }}
                                color="primaryOrange"
                                css={{
                                    maxWidth: '616px',
                                }}
                            >
                                {title}
                            </Typography>
                            <Typography
                                fontSize={{
                                    dt: 'xl',
                                    mb: 'base',
                                }}
                                color="shadesWhite"
                                css={{
                                    marginTop: '14px',
                                    maxWidth: '616px',
                                    marginBottom: '28px',
                                }}
                                dangerouslySetInnerHTML={{
                                    __html: bodyText,
                                }}
                            />
                            <Skeleton>
                                {frPhone && (
                                    <StyledButtonAsLink
                                        as={PhoneNumber}
                                        insetColor={colors.shadesBlack}
                                        to={`tel:${formatPhoneLink(frPhone)}`}
                                        isBig={false}
                                    >
                                        {formatPhoneLink(frPhone)}
                                    </StyledButtonAsLink>
                                )}
                            </Skeleton>
                        </div>
                    </Col>
                    <Col breakpoints={{
                        dt: { span: 6 },
                    }}
                    >
                        <div css={{
                            marginTop: '80px',
                            marginBottom: '96px',
                            [breakpoints.mb]: {
                                marginTop: '0',
                                marginBottom: '24px',
                            },
                        }}
                        >
                            <FormBuilder formId={linkedFormId} />
                        </div>
                    </Col>
                </Row>
            </Container>
        </section>
    );
};

export const query = graphql`
    fragment FranchiseFormCtaData on CmsPageBuilderBlocks {
        franchise_form_cta {
            title
            body_text
            linked_form_id
        }
    }
`;

export default FranchiseFormCta;
